import { m } from 'framer-motion';

import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { alpha } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
// import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography';

import { varHover } from '../components/animate'
import CustomPopover, { usePopover } from '../components/custom-popover';
import Iconify from '../components/iconify';
import axios from 'axios';

// ----------------------------------------------------------------------



export default function AccountPopover({ userName }) {
  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const LOGOUT = `${SERVER_URI}/logout`;

  const popover = usePopover();



  // const handleLogout = async () => {
  //   try {
  //     await logout();
  //     popover.onClose();
  //     router.replace('/');
  //   } catch (error) {
  //     console.error(error);
  //     enqueueSnackbar('Unable to logout!', { variant: 'error' });
  //   }
  // };

  const handleLogout = async () => {
    let token = localStorage.getItem("accessToken");
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      await axios.post(LOGOUT, {},config, { withCredentials: true });
      localStorage.clear();
      sessionStorage.clear();
      popover.onClose();
      setTimeout(() => {
        window.location.href = "/user_Login";
      }, 100);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };


  return (
    <>
      <div
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Stack
          flexGrow={1}

          direction="row"
          alignItems="center"
          // justifyContent="flex-end"
          spacing={{ xs: 0.5, sm: 1 }}
        >
          <Stack >
            <Iconify icon="gg:profile" width="1.5em" height="1.5em" />
          </Stack>
          <Typography variant="subtitle1" color="#1D53E7" fontWeight={600}>
            {userName}
          </Typography>
          <Iconify
            icon="teenyicons:down-solid"
            width="0.8rem"
            height="0.8rem"
            color="#858585"
          />
        </Stack>
      </div>

      <CustomPopover open={popover.open} onClose={popover.onClose} arrow='top-center' sx={{ width:{sm:380,xs:380,md: 200}, p: 0 }}>


        <Divider sx={{ borderStyle: 'dashed' }} />


        <MenuItem
          onClick={handleLogout}
          sx={{
            m: 1, justifyContent: "left",
            backgroundColor: "#FFECEC",
            color: "#F03D55",
            fontWeight: 600,
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#FFECEC",
              transform: "scale(1.05)",
              color: "#F03D55",
              fontWeight: 600,
            },
          }}
        >
          <Stack>
            <Iconify icon="ant-design:logout-outlined" />
          </Stack>{" "}
          &nbsp; Logout
        </MenuItem>

      </CustomPopover>
    </>
  );
}

AccountPopover.propTypes = {
  userName: PropTypes.string,
};